import { Button, Card, Form, Input, Modal, Rate, Tag } from "antd";
import React, { useState } from "react";
import Utils from "../../../utils/Utils";
import TextArea from "antd/es/input/TextArea";
import { reportSkillPostApi } from "../../../../api";
import Loader from "../../../Loader";

function SkillModal({
  skillModal,
  setSkillModal,
  skillModalData,
  interviewId,
  auth,
  interviewType,
  getReport,
}) {
  const [loading, setLoading] = useState(false);
  // console.log(skillModalData)
  const [tags, setTags] = useState({
    subSkillTags: skillModalData?.subSkills || [],
    strengthTags: skillModalData?.positiveRemarks || [],
    weaknessTags: skillModalData?.negativeRemarks || [],
  });

  const [tagInputValue, setTagInputValue] = useState({
    subSkillTagInputValue: "",
    strengthTagInputValue: "",
    weaknessTagInputValue: "",
  });

  const [errorTag, setErrorTag] = useState({
    subSkillErrorTag: false,
    strengthErrorTag: false,
    weaknessErrorTag: false,
  });

  const [editingIndex, setEditingIndex] = useState(null);

  const [formData, setFormData] = useState({
    strength: "",
    weakness: "",
    scoreFeedback: "",
    tags: [],
    scoreRating: null,
  });

  const [form] = Form.useForm();

  const handleInputConfirm = (inputName, tagName, errorName, e) => {
    const normalizedInputValue = tagInputValue[inputName].trim();
    const isDuplicate = tags[tagName].some(
      (tag, index) =>
        tag.toLowerCase() === normalizedInputValue.toLowerCase() &&
        index !== editingIndex // Check for duplicate while ignoring the currently edited tag
    );

    if (normalizedInputValue && !isDuplicate) {
      setTags((prevTags) => {
        const updatedTags = [...prevTags[tagName]];

        if (editingIndex !== null) {
          // Update tag if in edit mode
          updatedTags[editingIndex] = normalizedInputValue;
        } else {
          // Add new tag
          updatedTags.push(normalizedInputValue);
        }

        return { ...prevTags, [tagName]: updatedTags };
      });

      setEditingIndex(null); // Reset editing mode
      setTagInputValue({ subSkillTagInputValue: "" }); // Clear input
    } else if (isDuplicate) {
      setErrorTag((prev) => ({ ...prev, [errorName]: true }));
    }
  };

  const handleTagClick = (tag, index, inputvalue) => {
    // Populate input with the clicked tag for editing
    setTagInputValue({ [inputvalue]: tag });
    setEditingIndex(index); // Set index for editing
  };

  const handleTagRemove = (removedTag, inputTag, inputValue) => {
    setTagInputValue((prev) => ({
      ...prev,
      [inputValue]: "",
    }));
    setTags((prevTags) => ({
      ...prevTags,
      [inputTag]: prevTags[inputTag].filter((tag) => tag !== removedTag),
    }));
  };

  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleTagInputValue = (inputValue, error, e) => {
    setErrorTag((prev) => ({
      ...prev,
      [error]: false,
    }));
    setTagInputValue((prev) => ({
      ...prev,
      [inputValue]: e.target.value,
    }));
    if (e.target.value === "") setEditingIndex(null);
  };

  const postData = async (data) => {
    const url = `${reportSkillPostApi}`;
    try {
      setLoading(true); // Optional: to show a loading indicator

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      //   console.log(result);
      if (result.resultStatusInfo.resultCode.toLowerCase() === "success") {
        // setInterviewData(result.data.data);
        // console.log("Data posted successfully:", result.data.data);
        setSkillModal(false);
        getReport();
      } else {
        console.log(result.resultStatusInfo);
      }
    } catch (err) {
      console.error("Fetch error: ", err);
    } finally {
      setLoading(false); // Optional: to hide the loading indicator
    }
  };

  const handleFinish = (value) => {
    // console.log(value,);
    // let req = {
    //   scoreFeedback: value.scoreFeedback,
    //   scoreRating: value.scoreRating,
    //   strength: tags.strengthTags,
    //   weakness: tags.weaknessTags,
    //   subSkill: tags.subSkillTags,
    // };
    let req = {
      interviewId: interviewId,
      interviewType: interviewType,
      twoWayInterviewSkillAnalysisUpdateBody: {
        candidateInterviewSkillId: skillModalData.candidateInterviewSkillId,
        editedTags: tags.subSkillTags,
        editedPositiveRemarks: tags.strengthTags,
        editedNegativeRemarks: tags.weaknessTags,
        editedScore: value.scoreRating,
        editedVerdict: value.scoreFeedback,
      },
    };

    // console.log(req);

    postData(req);
  };

  return (
    <>
      {loading && <Loader />}

      <Modal
        title={
          <p className="text-[#206DC5] text-2xl">{skillModalData?.skill}</p>
        }
        footer={[null]}
        //   loading={loading}
        open={skillModal}
        onCancel={() => setSkillModal(false)}
        centered
        width={1000}
        style={{ backgroundColor: "#206DC5" }}
        className="custom-modal-wrap"
      >
        <Form onFinish={handleFinish} form={form}>
          <div>
            <Form.Item
              className="p-0 m-0"
              validateStatus={errorTag.subSkillErrorTag ? "error" : null}
              help={errorTag.subSkillErrorTag ? "Tag already exists!" : null}
              initialValue={{
                scoreFeedback: skillModalData?.verdict,
                scoreRating: skillModalData?.score,
              }}
            >
              <Input
                type="text"
                size="large"
                className="md:w-[50%] w-full"
                value={tagInputValue.subSkillTagInputValue}
                onChange={(e) => {
                  handleTagInputValue(
                    "subSkillTagInputValue",
                    "subSkillErrorTag",
                    e
                  );
                }}
                onPressEnter={(e) => {
                  e.preventDefault();
                  handleInputConfirm(
                    "subSkillTagInputValue",
                    "subSkillTags",
                    "subSkillErrorTag",
                    e
                  );
                }}
                disabled={tags.subSkillTags.length > 10}
                placeholder="Add tags and press Enter"
                // onChange={handleInputChange}
              />

              <div style={{ marginTop: "10px" }} className="">
                {tags.subSkillTags.length === 0 ? (
                  <Tag
                    // key={tag}
                    className="px-2 "
                    // closable

                    color="default"
                    style={{ borderRadius: "4px" }}
                  >
                    HTML
                  </Tag>
                ) : (
                  tags.subSkillTags.map((tag, index) => (
                    <Tag
                      key={tag}
                      className="px-2 cursor-pointer"
                      closable
                      onClose={() =>
                        handleTagRemove(
                          tag,
                          "subSkillTags",
                          "subSkillTagInputValue"
                        )
                      }
                      onClick={() =>
                        handleTagClick(tag, index, "subSkillTagInputValue")
                      }
                      color={Utils.getTagColor(index)}
                      style={{ borderRadius: "4px" }}
                    >
                      {tag}
                    </Tag>
                  ))
                )}
              </div>
            </Form.Item>
          </div>
          <div className="md:flex items-center block gap-3 mt-4">
            <Card className="md:w-[60%] w-full rounded-lg h-[340px] shadow-sm border-2 scroll overflow-y-auto">
              <p className="font-semibold text-xl">Strength</p>
              <Form.Item name="strength" className="mt-2">
                <Input
                  size="large"
                  className="py-3"
                  placeholder="Enter your feedback here..."
                  value={tagInputValue.strengthTagInputValue}
                  onChange={(e) => {
                    handleTagInputValue(
                      "strengthTagInputValue",
                      "strengthErrorTag",
                      e
                    );
                  }}
                  onPressEnter={(e) => {
                    e.preventDefault();
                    handleInputConfirm(
                      "strengthTagInputValue",
                      "strengthTags",
                      "strengthErrorTag",
                      e
                    );
                  }}
                  // suffix={
                  //   formData.strength && (
                  //     <Button type="primary" size="large">
                  //       Add
                  //     </Button>
                  //   )
                  // }
                />

                <div style={{ marginTop: "10px" }} className="">
                  {tags.strengthTags.map((tag, index) => (
                    <Tag
                      key={tag}
                      className="px-2 cursor-pointer mb-1"
                      closable
                      // onClose={() => handleTagRemove(tag)}
                      onClose={() =>
                        handleTagRemove(
                          tag,
                          "strengthTags",
                          "strengthTagInputValue"
                        )
                      }
                      onClick={() =>
                        handleTagClick(tag, index, "strengthTagInputValue")
                      }
                      color={Utils.getTagColor(index)}
                      style={{
                        borderRadius: "4px",
                        maxWidth: "100%", // Set fixed width
                        overflow: "visible", // Allow overflow to be visible
                        whiteSpace: "normal", // Allow text to wrap to the next line
                      }}
                    >
                      {tag}
                    </Tag>
                  ))}
                </div>
              </Form.Item>
              <p className="font-semibold text-xl mt-4">Weakness</p>
              <Form.Item name="weakness" className="mt-2">
                <Input
                  size="large"
                  className="py-3"
                  placeholder="Enter your feedback here and press Enter"
                  value={tagInputValue.weaknessTagInputValue}
                  onChange={(e) => {
                    handleTagInputValue(
                      "weaknessTagInputValue",
                      "weaknessErrorTag",
                      e
                    );
                  }}
                  onPressEnter={(e) => {
                    e.preventDefault();
                    handleInputConfirm(
                      "weaknessTagInputValue",
                      "weaknessTags",
                      "weaknessErrorTag",
                      e
                    );
                  }}
                />

                <div style={{ marginTop: "10px" }} className="">
                  {tags.weaknessTags.map((tag, index) => (
                    <Tag
                      key={tag}
                      className="px-2 cursor-pointer mb-1"
                      closable
                      // onClose={() => handleTagRemove(tag)}
                      onClose={() =>
                        handleTagRemove(
                          tag,
                          "weaknessTags",
                          "weaknessTagInputValue"
                        )
                      }
                      onClick={() =>
                        handleTagClick(tag, index, "weaknessTagInputValue")
                      }
                      color={Utils.getTagColor(index)}
                      style={{
                        borderRadius: "4px",
                        maxWidth: "100%", // Set fixed width
                        overflow: "visible", // Allow overflow to be visible
                        whiteSpace: "normal", // Allow text to wrap to the next line
                      }}
                    >
                      {tag}
                    </Tag>
                  ))}
                </div>
              </Form.Item>
            </Card>
            <Card className="md:w-[40%] w-full rounded-lg shadow-sm md:mt-0 mt-4 h-[340px] items-center  border-2">
              <p className="font-semibold text-center text-xl mt-10">
                Score Justification
              </p>
              <Form.Item
                name="scoreFeedback"
                className="mt-2"
                initialValue={skillModalData?.verdict}
              >
                <TextArea
                  onChange={handleInputChange}
                  placeholder="Enter your feedback here"
                  style={{
                    height: 120,
                    width: "100%",
                    resize: "none",
                  }}
                  // defaultValue={skillModalData?.skillScoreJustification}
                />
              </Form.Item>
              <Form.Item
                name="scoreRating"
                className="p-0 m-0 text-center"
                initialValue={skillModalData?.score}
              >
                <Rate
                  allowHalf
                  onChange={(value) =>
                    handleInputChange({
                      target: { name: "scoreRating", value },
                    })
                  }
                  style={{
                    fontSize: 38,
                  }}
                />
              </Form.Item>
            </Card>
          </div>
          <div className="flex  md:justify-end justify-center  items-center gap-4 mt-6">
            <Button
              onClick={() => setSkillModal(false)}
              size="large"
              className="md:w-[200px] w-full"
            >
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              className="md:w-[200px] w-full"
              htmlType="submit"
            >
              Update
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}

export default SkillModal;
